import React from 'react'
import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import NewCollections from './NewCollections'
import HotStacking from './HotStacking'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const HotSection = () => {
  const { account } = useWeb3React()

  return (
    <Container>
      <NewCollections />
      <HotStacking account={account} />
    </Container>
  )
}

export default HotSection
